import { isToday } from '@/utils/date/is-today';
import { isTomorrow } from '@/utils/date/is-tomorrow';

export const padDates = (anyDate: Date | string) => {
  const date = new Date(anyDate);

  if (isNaN(date.getTime())) {
    return {};
  }

  return {
    get day(): string {
      return date.getDate().toString().padStart(2, '0');
    },
    get month(): string {
      return (date.getMonth() + 1).toString().padStart(2, '0');
    },
    get year(): string {
      return `${date.getFullYear()}`;
    },
  };
};

export const ddmonthyyyy = (date: Date, showYear = true): string => {
  const { day, month, year } = padDates(date);
  const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

  if (!month) {
    return '';
  }

  return `${Number(day)} ${months[parseInt(month) - 1]} ${showYear ? year : ''}`;
};

export const yyyymmdd = (date: Date, delimiter = '.') => {
  const { day, month, year } = padDates(date);

  return `${year}${delimiter}${month}${delimiter}${day}`;
};

export const ddmmyyyy = (date: Date, delimiter = '.') => {
  const { day, month, year } = padDates(date);

  return `${day}${delimiter}${month}${delimiter}${year}`;
};

export const ddmmyy = (date: Date, delimiter = '.') => {
  const { day, month } = padDates(date);
  const year = `${date.getFullYear().toString().substring(2)}`;

  return `${day}${delimiter}${month}${delimiter}${year}`;
};

export const ddmm = (date: Date, delimiter = '.') => {
  const { day, month } = padDates(date);

  return `${day}${delimiter}${month}`;
};

export const dd = (date: Date) => {
  const { day } = padDates(date);

  return `${day}`;
};

export const dateToVerbal = (date: Date | string): string => {
  let localDate: Date;

  if (typeof date === 'string') {
    localDate = new Date(date);

    if (isNaN(localDate.getTime())) {
      return date;
    }
  } else {
    localDate = date;
  }

  if (isToday(localDate)) {
    return 'сегодня';
  } if (isTomorrow(localDate)) {
    return 'завтра';
  }

  return ddmmyyyy(localDate);
};

export const dateToCapitalizedVerbal = (date = new Date()) => {
  let verbal = ddmm(date);

  if (isToday(date)) {
    verbal = 'Сегодня';
  } else if (isTomorrow(date)) {
    verbal = 'Завтра';
  }
  return verbal;
};

